import { GCLID_PARAM, GBRAID_PARAM, WBRAID_PARAM } from "./constants";
import type { ClickIds } from "./types";

const MAX_CLICK_ID_LENGTH = 200;

function normalizeClickId(value: string | null | undefined) {
  const trimmed = value?.trim();
  if (!trimmed || trimmed.length > MAX_CLICK_ID_LENGTH) {
    return undefined;
  }
  return trimmed;
}

export function parseClickIdsFromSearch(search: string): ClickIds | null {
  const params = new URLSearchParams(
    search.startsWith("?") ? search.slice(1) : search,
  );
  const gclid = normalizeClickId(params.get(GCLID_PARAM));
  const gbraid = normalizeClickId(params.get(GBRAID_PARAM));
  const wbraid = normalizeClickId(params.get(WBRAID_PARAM));

  if (!gclid && !gbraid && !wbraid) {
    return null;
  }

  return {
    ...(gclid ? { gclid } : {}),
    ...(gbraid ? { gbraid } : {}),
    ...(wbraid ? { wbraid } : {}),
    capturedAt: Date.now(),
  };
}
